module.exports = __webpack_public_path__ + "static/media/carat-l-black.b3b2c4ff.svg";